module.exports = __webpack_public_path__ + "img/w56b.ab761df5.jpg";